import type {
  CauseAndEffect,
  FactOpinionSorter,
} from "@/types/models/Exportables.interface";

/**
 * Clears optional fields for specific template types when loading from SETI
 * by the LunaAutoFillButton which will populate them with AI suggestions when toggled.
 */
export const clearOptionalFields = (
  templateData: Record<string, any>,
  shouldClearOptionalFields: boolean,
  templateSetiIdentifier: string,
): Record<string, any> => {
  if (!shouldClearOptionalFields) {
    return templateData;
  }

  if (templateSetiIdentifier === "cause_effect") {
    const causesAndEffects =
      (templateData as CauseAndEffect).causes_and_effects ?? [];
    return {
      ...templateData,
      causes_and_effects: causesAndEffects.map((pair, idx) =>
        idx === 0
          ? {
              cause: pair.cause ?? "",
              effect: pair.effect ?? "",
              source_text: pair.source_text ?? "",
            }
          : {
              cause: "",
              effect: "",
              source_text: "",
            },
      ),
    };
  }

  if (templateSetiIdentifier === "fact_opinion") {
    const statements = (templateData as FactOpinionSorter).statements ?? [];
    return {
      ...templateData,
      statements: statements.map(({ statement }) => ({
        statement,
        classification: "",
        explanation: "",
      })),
    };
  }

  if (templateSetiIdentifier === "primary_source_analysis") {
    return {
      ...templateData,
      intended_audience: "",
      conclusion: "",
      evidence_of_bias: "",
      excluded_topics: "",
      reliability: "",
      world_events: "",
    };
  }

  return templateData;
};
